import React, { FunctionComponent } from "react";

import { SentryRoute } from "../sentry";

type OwnPropsType = {
  exact?: boolean;
  path: string;
  component: React.ComponentType<any>;
};

const PublicRoute: FunctionComponent<OwnPropsType> = ({
  /* eslint-disable-next-line @typescript-eslint/naming-convention */
  component: Component,
}) => {
  return (
    <>
      <SentryRoute
        render={(props) => (
          <>
            <Component {...props} />
          </>
        )}
      />
    </>
  );
};

export default PublicRoute;
